import { makeLink } from "./links";
import { urls, contactEmail } from "./urls";
import { type FAQ } from "./FAQ.en";
import { get } from "svelte/store";

export const faq = (): FAQ => ({
  title: "FOIRE AUX QUESTIONS SUR LA PROMOTION CALL OF DUTY<sup>MD</sup> DE LITTLE CAESARS<sup>MD</sup>",
  subtitle: "",
  q: "Q:",
  a: "R:",
  qaList: [
    {
      question: "Vous éprouvez un problème technique sur le site Web de la promotion?",
      answer: [{
        type: "string",
        content: `Veuillez essayer de vider votre cache, d'actualiser la page ou d'ouvrir une nouvelle fenêtre dans un autre navigateur. Si le problème persiste, veuillez nous envoyer un courriel au ${makeLink(get(urls).contactUs, contactEmail)} en incluant une capture d'écran, l'information relative à votre navigateur/appareil ainsi qu'un message détaillé décrivant votre problème.`
      }]
    },
    {
      question: "Qui est admissible à cette promotion?",
      answer: [{
        type: "string",
        content: `Le tirage au sort Call of Duty de Little Caesars ne s'adresse qu'aux résidents légaux des cinquante (50) États des États-Unis et de DC, du Canada (à l'exclusion de la province du Québec) et du Mexique qui sont âgés d'au moins dix-huit (18) ans à la date/heure de participation. Veuillez consulter le ${makeLink(get(urls).officialRules, "règlement officiel")} pour plus de détails.`
      }]
    },
    {
      question: "Dois-je m'inscrire et lier mon compte Activision à chaque fois que je souhaite participer?",
      answer: [{
        type: "string",
        content: `Vous serez invité à vous inscrire et à lier votre compte Activision à chaque participation. Cependant, votre appareil peut ignorer l'authentification Activision si vous l'avez déjà fait au cours des dernières 24 heures.`
      }]
    },
    {
      question: "Qu'est-ce qui définit un « achat admissible » pour débloquer des récompenses en jeu?",
      answer: [{
        type: "string",
        content: `Il s'agit d'une commande en restaurant ou en ligne d'un produit alimentaire ou d'une boisson auprès d'un restaurant Little Caesars participant qui atteint les sous-totaux minimaux suivants (avant taxes/frais) dans les pays suivants :`
      }, {
        type: "list",
        content: [
          "États-Unis : 3 $ US",
          "Canada : 4,99 $ CAD",
          "Mexique : 50 $ MXN"
        ]
      }, {
        type: "string",
        content: `Les commandes provenant de sites de livraison tiers et de Kmart, de stades, ainsi que des emplacements Little Caesars Express et concept ne sont pas admissibles aux récompenses en jeu.`
      }, {
        type: "string",
        content: `Un « achat admissible » n'est pas requis pour participer. Consultez le ${makeLink(get(urls).officialRules, "règlement officiel")} pour savoir comment participer sans achat.`
      }]
    },
    {
      question: "Comment puis-je participer pour obtenir des récompenses en jeu et des prix?",
      answer: [{
        type: "string",
        content: `Pour les achats admissibles effectués dans un restaurant aux États-Unis, vous recevrez un code au bas de votre reçu imprimé. Entrez ce code sur ce site pour débloquer la récompense ou le prix. Si, pour une raison quelconque, un code ne s'imprime pas sur le reçu de votre achat admissible en restaurant, veuillez contacter le service client de Little Caesars à ${makeLink(get(urls).contactLittleCaesars, "Contactez-nous - Little Caesars®")}.`
      }, {
        type: "string",
        content: `Pour les achats admissibles en restaurant au Canada et au Mexique, vous recevrez un code au bas de votre reçu imprimé. Entrez ce code sur ce site pour débloquer la récompense ou le prix. Si, pour une raison quelconque, un code ne s'imprime pas sur le reçu de votre Achat Admissible en restaurant, vous pouvez téléverser une photo de votre reçu sur ce site pour vérification. La récompense ou le prix sera débloqué une fois votre reçu vérifié. Les téléversements de reçus avec des codes seront rejetés.`
      }, {
        type: "string",
        content: `Pour savoir comment participer sans achat, consultez le ${makeLink(get(urls).officialRules, "règlement officiel")}.`
      }, {
        type: "string",
        content: `Les participants du Mexique et du Canada devront répondre correctement à une question de compétence pour recevoir une récompense ou un prix.`
      }]
    },
    {
      question: "Que puis-je gagner?",
      answer: [{
        type: "string",
        content: `Vous pouvez débloquer l'un des prix ou récompenses suivants avec chaque participation admissible afin d'améliorer l'expérience de jeu dans <i>Call of Duty: Black Ops 7</i>, sélectionné au hasard lors de la participation.`
      }, {
        type: "string",
        content: `Prix (limite de deux [2] au total par personne) :`
      }, {
        type: "list",
        content: [
          "Passe de combat + 15 minutes de Dual 2XP",
          "Points Call of Duty selon les nombres suivants : 500, 1 100, 2 400 et 13 000 (nombres attribués au hasard) + 15 minutes de Dual 2XP"
        ]
      }, {
        type: "string",
        content: `Récompenses :`
      }, {
        type: "list",
        content: [
          "Apparence d'opérateur + 30 minutes de Dual 2XP",
          "Emblème + 30 minutes de Dual 2XP",
          "Porte-bonheur + 30 minutes de Dual 2XP",
          "Carte de visite + 30 minutes de Dual 2XP",
          "Une (1) heure de Dual 2XP"
        ]
      }]
    },
    {
      question: "Puis-je débloquer le même article plusieurs fois?",
      answer: [{
        type: "string",
        content: `Il est possible que votre participation débloque le même article si vous participez plusieurs fois. Si vous débloquez l'apparence d'opérateur, la carte de visite, l'emblème ou le porte-bonheur (« récompenses Little Caesars ») ou le prix d'une passe de combat plus d'une fois, ces articles ne seront appliqués à votre compte Activision que la première fois. Si vous débloquez ces articles de nouveau, vous ne recevrez que le Dual 2XP pour monter de niveau dans le jeu.`
      }, {
        type: "string",
        content: `Limite de deux (2) prix au total par personne. Vous pouvez continuer de participer une fois par jour pour débloquer des récompenses supplémentaires, même après avoir atteint votre limite de prix. Maximum de quarante (40) heures de Dual 2XP au total qui s'applique à la fois aux prix et aux récompenses de toutes les promotions Dual 2XP pour <i>Call of Duty: Black Ops 7</i> et Call of Duty : WarzoneMC (ne se limitant pas à cette promotion).`
      }]
    },
    {
      question: "Combien de fois puis-je participer par jour?",
      answer: [{
        type: "string",
        content: `Vous pouvez participer jusqu'à une (1) fois par jour.`
      }]
    },
    {
      question: "Quand recevrai-je ma récompense ou mon prix?",
      answer: [{
        type: "string",
        content: `Votre récompense ou votre prix sera remis dans les 48 heures. Des détails spécifiques sur la récompense ou le prix que vous avez gagné vous seront envoyés par courriel immédiatement après votre participation.`
      }]
    },
    {
      question: "Que dois-je faire si je ne vois pas ma passe de combat, le Dual 2XP ou les récompenses Little Caesars dans le jeu?",
      answer: [{
        type: "string",
        content: `Si vous étiez connecté au jeu lorsque vous avez entré votre code ou lorsque votre reçu a été vérifié, veuillez essayer de redémarrer le jeu pour recevoir votre contenu numérique. Si votre passe de combat, le Dual 2XP ou les récompenses Little Caesars sont toujours manquants, veuillez contacter l'${makeLink(get(urls).activisionSupport, "assistance d'Activision")} pour obtenir de l'aide. Veuillez noter que la passe de combat ne sera livrée dans le jeu qu'au début de la saison 1 de <i>Call of Duty: Black Ops 7</i>, qui sortira plus tard cette année.`
      }]
    },
    {
      question: "J'ai reçu un code par courriel pour des points Call of Duty. Où puis-je l'échanger?",
      answer: [{
        type: "string",
        content: `Vous devez vous connecter au compte de votre première partie sur l'une des plateformes suivantes pour y saisir le code:`
      }, {
        type: "list",
        content: [
          `Xbox®: ${makeLink("https://www.xbox.com/redeem")}`,
          `PlayStation®: ${makeLink("https://www.playstation.com/")} (sélectionnez l'icône du profil)`,
          `Battle.net: ${makeLink("https://us.shop.battle.net/")} (sélectionnez le profil en haut à droite)`,
          `Steam: ${makeLink("https://www.callofduty.com/redeem")}`,
          `Xbox on PC: ${makeLink("https://www.xbox.com/redeem")}`
        ]
      }, {
        type: "string",
        content: `Si vous éprouvez des difficultés lors de l'échange de points Call of Duty alors que vous étiez connecté au jeu lorsque vous avez saisi votre code, essayez de redémarrer le jeu pour recevoir votre contenu numérique.`
      }]
    },
    {
      question: "Combien de temps dure la promotion?",
      answer: [{
        type: "string",
        content: `Les achats admissibles doivent être effectués entre le 3 novembre 2025 à 12 h 00 min 01 s HE et le 31 décembre 2025 à 23 h 59 min 59 s HE, et entrés avant le 31 janvier 2026 à 23 h 59 min 59 s HE afin de débloquer des récompenses et des prix.`
      }]
    },
    {
      question: "Vous ne voyez pas votre question ou problème ici?",
      answer: [{
        type: "string",
        content: `Veuillez envoyer un courriel au ${makeLink(get(urls).contactUs, contactEmail)}.`
      }]
    }
  ],
  footnote: `EN CAS DE DIVERGENCE OU DE CONTRADICTION ENTRE LES RENSEIGNEMENTS OU AUTRES DÉCLARATIONS CONTENUS DANS LA PRÉSENTE FOIRE AUX QUESTIONS ET LES CONDITIONS GÉNÉRALES DU ${makeLink(get(urls).officialRules, "RÈGLEMENT OFFICIEL")}, LE ${makeLink(get(urls).officialRules, "RÈGLEMENT OFFICIEL")} PRÉVAUDRA, RÉGIRA ET CONTRÔLERA.`
});
